import { createStyles, rem } from '@mantine/core'

type StyleParams = {
  backgroundColor: string
}

export default createStyles((theme, { backgroundColor }: StyleParams) => {
  return {
    root: {
      backgroundColor,
      ...(backgroundColor && {
        padding: `${rem(48)} 0`,
      }),
      [theme.fn.smallerThan('sm')]: {
        overflow: 'hidden',
      },
      '.customize-item': { height: '100%' },
    },
    inner: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      [theme.fn.largerThan('sm')]: {
        gap: 48,
      },
    },
    header: {
      [theme.fn.largerThan('sm')]: {
        textAlign: 'center',
      },
    },
  }
})
